import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, User, sendPasswordResetEmail} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD0Hw-eJGcWY69TT20x3sUpZNIbiktZYQU",
  authDomain: "gran-recogida.firebaseapp.com",
  projectId: "gran-recogida",
  storageBucket: "gran-recogida.appspot.com",
  messagingSenderId: "641674197485",
  appId: "1:641674197485:web:dd3dc350bff0f9c8b00fe4"
};

interface ErrorTranslations {
  [index: string]: string;
}

const errorMessages: ErrorTranslations = {
  "auth/email-already-in-use": "Este email ya tiene una cuenta"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  signInWithPopup(auth, googleProvider).then(async (result) => {
  }).catch((error) => {
    console.error(error);
    alert(error.message);
  });
};

const loginInWithEmailAndPassword = async (email: string, password: string) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch(err) {
    console.error(err);
    alert(err);
  }
}

const registerWithEmailAndPassword = async (name: string, email: string, password: string): Promise<User | void> => {
  return createUserWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    return Promise.resolve(userCredential.user);
  })
  .catch((error) => {
    return Promise.reject(errorMessages[error.code]);
  });
};

const resetPassword = async(email: string) => {
  return sendPasswordResetEmail(auth, email);
}

const logout = () => {
  auth.signOut();
};

export {
  auth,
  signInWithGoogle,
  logout,
  loginInWithEmailAndPassword,
  registerWithEmailAndPassword,
  resetPassword,
};
